﻿$.fn.dxCtrlEmailLstTag = function custom_dxCtrlEmailLstTag(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlemailsttag dx-ctrl");
        this.createInstance(new cdxCtrlEmailLstTag(this, option));
    }
    return this;
}

window.cdxCtrlEmailLstTag = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.allowChampForDestinataire == 'undefined') option.allowChampForDestinataire = true

    var $DivDetail = null;
    var $TdBtNewChamp = null
    function mConstruit() {
        container.empty()

        if (typeof option.bddCtrl.lstChampsMerge == 'undefined' || option.bddCtrl.lstChampsMerge == null) {
            option.bddCtrl.mAjaxCall({ command: "getchampmerge" }, function (data) {
                option.bddCtrl.lstChampsMerge = []
                var idx = 1
                data.champs.forEach(function (champ) {
                    if (champ.is_champ_for_destinataire == "0" || (champ.is_champ_for_destinataire == "1" && option.allowChampForDestinataire)) {
                        var grp = option.bddCtrl.lstChampsMerge.filter(function (o) { return o.libelle == champ.type })[0]
                        if (typeof grp == 'undefined') {
                            grp = {
                                id: idx,
                                libelle: champ.type,
                                champs: []
                            }
                            option.bddCtrl.lstChampsMerge.push(grp)
                            idx += 1
                        }
                        if (champ.nom_champ.length > 0) {
                            var champSource = grp.champs.filter(function (o) { return o.libelle.substring(0, o.libelle.length - 1) == champ.libelle.split(":")[0] })[0]
                            if (typeof champSource.lstChamps == 'undefined') champSource.lstChamps = []
                            champSource.lstChamps.push(champ)
                        } else {
                            grp.champs.push(champ)
                        }
                    }
                })
                mConstruit()
            })
        } else {
            var $Table = $("<table style='width:100%;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdDxTabs = $("<td style='width:100%;'></td>").appendTo($Tr)
            $TdBtNewChamp = $("<td style='width:1px;display:none;padding-left:5px;'></td>").appendTo($Tr)
            $("<div/>").appendTo($TdBtNewChamp).dxCtrlButton({
                icon: "fas fa-wand-magic-sparkles",
                hint: "Créer un nouveau champ de saisie<br/>Créer des champs libre à insérer dans le document. Ces champs seront a saisir au moment de la création du document.",
                width: 36,
                height: 36,
                onClick: function (e) {
                    mCreateNewChamp(e.component.element())
                }
            })
            var $Td = $("<td style='width:1px;padding-left:5px;'></td>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: 'fas fa-times',
                width: 36,
                height: 36,
                onClick: function (e) {
                    option.onClose()
                }
            })

            $DivDetail = $("<div style=''/>").appendTo(container)
            resizeObserver.mAdd($Table, function () { $DivDetail.css("height", "calc(100% - " + $Table.innerHeight() + "px)") })

            var ds = [{ id: 0, icon: "fas fa-database", tooltip: "Champs de votre base de données" }]
            if (typeof option.lstChampSaisie != "undefined") ds.push({ id: 1, icon: "fas fa-pen", tooltip: "Champs à saisir dans votre document" })
            dxTabs = $("<div/>").appendTo($TdDxTabs).dxTabs({
                dataSource: ds,
                width: "100%",
                height: "100%",
                rtlEnabled: false,
                showNavButtons: false,
                orientation: "horizontal",
                stylingMode: "primary",
                iconPosition: "top",
                selectedItem: ((typeof option.lstChampSaisie == "undefined" || option.lstChampSaisie.length == 0) ? ds[0] : ds[ds.length - 1]),
                itemTemplate: function (data, index, element) {
                    element.parent().attr("title", data.tooltip)
                    element.css({
                        "padding-top": "5px",
                        "padding-bottom": "5px"
                    })
                    return "item"
                },
                onItemClick: function (e) {
                    if (e.itemData.id == 0) { mRempliBdd() }
                    else { mRempliChamp() }
                },
                onContentReady: function (e) {
                    e.component.element().find(".dx-tab").css({
                        "background-color": theme.backgroundcolorTooltip,
                        "min-width": "30px",
                        "padding-right": "5px",
                        "padding-left": "5px"
                    })
                }
            }).dxTabs("instance")

            if (typeof option.lstChampSaisie == "undefined" || option.lstChampSaisie.length == 0) { mRempliBdd() }
            else { mRempliChamp() }

            //var $Div = $("<div style='padding:5px 5px 0 0;height:calc(100% - " + $Table.innerHeight() + "px);'/>").appendTo(container)
            //var dxTabs = null
            //if (typeof option.lstChampSaisie != "undefined") {
            //    var ds = ["Base de données", "Saisie"]
            //}

            //window.setTimeout(function () {
            //    $Div.css("height", "calc(100% - " + $Table.innerHeight() + "px)")
            //    $DivDetail = $("<div style='height:calc(100% - " + ((dxTabs) ? dxTabs.element().innerHeight() : 0) + "px);'/>").appendTo($Div)
            //    if (typeof option.lstChampSaisie == "undefined") { mRempliBdd() }
            //    else { mRempliChamp() }
            //}, 100)
        }

    }

    function mRempliBdd() {
        $DivDetail.empty()
        $TdBtNewChamp.hide()
        var dxScroll = $("<div style='height:100%;width:100%;'/>").appendTo($DivDetail).dxScrollView({}).dxScrollView("instance")
        if (typeof option.bddCtrl.utiCourantParaJson.champmerge_selectedids == 'undefined') {
            option.bddCtrl.utiCourantParaJson.champmerge_selectedids = [1]
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
        var lstChampMergeFilter = option.bddCtrl.lstChampsMerge.filter(function (o) {
            return o.libelle == "DESTINATAIRE" || o.libelle == "UTILISATEUR" || o.libelle == "COMPTE CLIENT" || (o.libelle == "SOCIETE" && option.bddCtrl.objCptCli.objetMetier.hasDocCpt())
        })
        if (typeof option.lstLibelleAdded != 'undefined') {
            option.lstLibelleAdded.forEach(function (lib) {
                option.bddCtrl.lstChampsMerge.forEach(function (ch) {
                    if (ch.libelle == lib) lstChampMergeFilter.push(ch)
                })
            })
        }

        $("<div syle='width:100%;height:100%;'/>").appendTo(dxScroll.content()).dxCtrlAccordion({
            dataSource: lstChampMergeFilter,
            multiple: false,
            selectedIds: option.bddCtrl.utiCourantParaJson.champmerge_selectedids,
            itemClosed: function (itemData) {
                option.bddCtrl.utiCourantParaJson.champmerge_selectedids.splice(option.bddCtrl.utiCourantParaJson.champmerge_selectedids.indexOf(itemData.id), 1)
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            itemOpened: function (itemData) {
                option.bddCtrl.utiCourantParaJson.champmerge_selectedids.push(itemData.id)
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.text(itemData.libelle)
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                //debugger;
                //itemElement.css("padding", "0")
                $("<div/>").appendTo(itemElement).dxTreeView({
                    dataSource: itemData.champs,
                    itemsExpr: "lstChamps",
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        itemElement.css("cursor", "default")
                        var $Table = $("<table/>").appendTo(itemElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                        var lib = itemData.libelle
                        //if (typeof itemData.nom_champ != 'undefined' && itemData.nom_champ.length > 0) lib = itemData.libelle.replace("}", "|" + itemData.nom_champ + "}")
                        $("<div/>").appendTo($Td).dxCtrlButton({
                            icon: "fas fa-arrow-left",
                            hint: "Ajouter le champ<br/>au document",
                            height: 22,
                            width: 22,
                            onClick: function (e) {
                                e.event.stopPropagation()
                                var htmlEditor = option.elementEditorHtml.getCurrentEditorHtml()
                                if (htmlEditor) {
                                    switch (lib) {
                                        case "{LIEN_DESINSCRIPTION}":
                                            var $A = $("<a href='{LIEN_DESINSCRIPTION}' target='_blank' class='ADesinscription champdoc'></a>")
                                            $A.text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription"))
                                            htmlEditor.insertContent($A[0].outerHTML)
                                            break;
                                        case "{https://lien_ouvrir_email_dans_navigateur}":
                                            var $A = $("<a href='https://lien_ouvrir_email_dans_navigateur' target='_blank' class='AViewBrowser champdoc'></a>")
                                            $A.text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_vue_browser"))
                                            htmlEditor.insertContent($A[0].outerHTML)
                                            break;
                                        default:
                                            htmlEditor.insertContent("<span contenteditable='false' class='champdoc'>" + lib + "</span>")
                                            break;
                                    }
                                }
                                else { mNotify("Impossible d'intégrer le champs. Veuillez sélectionner un éditeur HTML.", "warning", 6000) }
                            }
                        })
                        var $Td = $("<td style='width:100%;'>" + lib + "</td>").appendTo($Tr)
                    }
                })
            },
            onContentReady: function (e) {
                e.element.find(".dx-accordion-item-title").css("overflow", "hidden")
                e.element.find(".dx-accordion-item-title").css("border", "none")
            }
        })
    }

    function mGetMaxIndexChamp() {
        var index = 0
        option.lstChampSaisie.forEach(function (o, idx) { if (index < o.idx) index = o.idx })
        return index
    }

    var dxListChamp = null
    function mRempliChamp() {
        $DivDetail.empty()
        $DivDetail.css("position", "relative")

        option.lstChampSaisie.forEach(function (o, idx) { if (typeof o.idx == 'undefined') o.idx = idx + 1 })

        $TdBtNewChamp.show()
        dxListChamp = $("<div/>").appendTo($DivDetail).dxList({
            items: option.lstChampSaisie,
            noDataText: "<div style='padding:20px;text-align:center;'>(Aucun champs de saisie)</div>",
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css({
                    "padding": "2px",
                    margin: "5px"
                })
                itemElement.attr("title", itemData.description)

                var $Table = $("<table style='width:100%;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-arrow-left",
                    hint: "Ajouter le champ<br/>au document",
                    height: 28,
                    width: 28,
                    onClick: function (e) {
                        e.event.stopPropagation()
                        var htmlEditor = option.elementEditorHtml.getCurrentEditorHtml()
                        if (htmlEditor) {
                            switch (itemData.nom) {
                                //case "{LIEN_DESINSCRIPTION}":
                                //    var $A = $("<a href='{LIEN_DESINSCRIPTION}' target='_blank' class='ADesinscription'></a>")
                                //    $A.text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_desinscription"))
                                //    htmlEditor.insertContent($A)
                                //    break;
                                //case "https://lien_ouvrir_email_dans_navigateur":
                                //    var $A = $("<a href='https://lien_ouvrir_email_dans_navigateur' target='_blank' class='AViewBrowser'></a>")
                                //    $A.text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_vue_browser"))
                                //    htmlEditor.insertContent($A)
                                //    break;
                                default:
                                    htmlEditor.insertContent("<span contenteditable='false' class='chppopsoft" + itemData.idx + " champdocsaisie'>{" + itemData.nom + "}</span>")
                                    break;
                            }
                        }
                    }
                })
                var $Td = $("<td style='width:100%;padding-right:5px;'/>").appendTo($Tr)
                mAddCtrlChamp($Td, itemData.type_champ, itemData.nom, itemData.detail, itemData.value, "Saisissez la valeur dans le document",
                    function (e) {
                        itemData.value = ((e.value == null) ? "" : e.value)
                        option.onLstChampSaisieChanged(option.lstChampSaisie)
                    }).element().css("padding-top", "5px")
                //$("<div style='padding-top:5px'/>").appendTo($Td).dxTextBox({
                //    width: "100%",
                //    labelMode: 'floating',
                //    label: itemData.nom,
                //    placeholder: "Saisissez une valeur",
                //    value: itemData.value,
                //    onValueChanged: function (e) {
                //        itemData.value = ((e.value == null) ? "" : e.value)
                //        option.onLstChampSaisieChanged(option.lstChampSaisie)
                //    }
                //})
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-pen",
                    txtTooltip: "modifier le champ",
                    height: 28,
                    width: 28,
                    onClick: function (e) {
                        e.event.stopPropagation()
                        mDisplayChamp(itemData, function () {
                            if (typeof option.elementEditorHtml.getLstEditorHtml != 'undefined') {
                                option.elementEditorHtml.getLstEditorHtml().forEach(function (htmlEditor) {
                                    htmlEditor.getCurrentEditorHtml().dom.select(".chppopsoft" + itemData.idx).forEach(function (ele) { $(ele).html(itemData.nom) })
                                })
                            } else {
                                var htmlEditor = option.elementEditorHtml.getCurrentEditorHtml()
                                if (htmlEditor) {
                                    htmlEditor.dom.select(".chppopsoft" + itemData.idx).forEach(function (ele) { $(ele).html(itemData.nom) })
                                }
                            }
                        })
                    }
                })
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-delete-left fa-rotate-180",
                    txtTooltip: "Supprimer le champ",
                    height: 28,
                    width: 28,
                    onClick: function (e) {
                        e.event.stopPropagation()
                        if (typeof option.elementEditorHtml.getLstEditorHtml != 'undefined') {
                            option.elementEditorHtml.getLstEditorHtml().forEach(function (htmlEditor) {
                                htmlEditor.getCurrentEditorHtml().dom.select(".chppopsoft" + itemData.idx).forEach(function (ele) { ele.remove() })
                            })
                        } else {
                            var htmlEditor = option.elementEditorHtml.getCurrentEditorHtml()
                            if (htmlEditor) {
                                htmlEditor.dom.select(".chppopsoft" + itemData.idx).forEach(function (ele) { ele.remove() })
                            }
                        }
                        option.lstChampSaisie.splice(option.lstChampSaisie.indexOf(itemData), 1)
                        option.onLstChampSaisieChanged(option.lstChampSaisie)
                        dxListChamp.option({
                            "items": option.lstChampSaisie,
                            itemDragging: {
                                data: option.lstChampSaisie
                            }
                        })
                    }
                })
            },
            repaintChangesOnly: true,
            itemDragging: {
                allowReordering: true,
                data: option.lstChampSaisie,
                group: "tasks",
                onDragStart: function (e) {
                    e.itemData = e.fromData[e.fromIndex];
                },
                onDragEnd: function (e) {
                    //alert("TODO")
                    if (e.fromIndex != e.toIndex) {
                        var itemDataSource = e.fromData[e.fromIndex]
                        var itemDataDestination = e.toData[e.toIndex] //item se trouvant avant l'endroit ou on insère l'item
                        window.setTimeout(function () {
                            e.component.option("items").forEach(function (item, idx) {
                                if (item.tri != idx) {
                                    item.tri = idx
                                }
                            })
                            option.onLstChampSaisieChanged(option.lstChampSaisie)
                        }, 0)
                    }
                }
            }
        }).dxList("instance")
    }

    //type_champ
    //1 = string
    //2 = string multiligne
    //3 = date
    //4 = chiffre
    //5 = chiffre en lettre
    //6 = liste de choix
    function mCreateNewChamp(target) {
        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            target: target,
            width: 300,
            contentTemplate: function (contentElement) {
                var ds = [1, 2, 3, 4, 5]
                $("<div class='dxctrllist'/>").appendTo(contentElement).dxList({
                    dataSource: { pageSize: 99999, store: ds },
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        itemElement.css({
                            "padding-top": "10px",
                            "padding-bottom": "10px",
                            "border-bottom": theme.border
                        })
                        itemElement.addClass("state-hover")
                        var $Table = $("<table style='width:100%;white-space:normal;text-align:left;'/>").appendTo(itemElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px;vertical-align:top;font-size:150%;padding-right:10px;' rowspan='2'/>").appendTo($Tr)
                        switch (itemData) {
                            case 1:
                                $("<i class='fas fa-z'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champ texte simple</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i>Champ texte sur une seule ligne</i></td>").appendTo($Tr)
                                break;
                            case 2:
                                $("<i class='fas fa-z'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champ texte multiligne</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i>Champ texte sur plusieurs lignes</i></td>").appendTo($Tr)
                                break;
                            case 3:
                                $("<i class='fas fa-calendar-days'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champ date</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i></i></td>").appendTo($Tr)
                                break;
                            case 4:
                                $("<i class='fas fa-9'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champ numérique</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i>Saisie d'un chiffre</i></td>").appendTo($Tr)
                                break;
                            case 5:
                                $("<i class='fas fa-9'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champ numérique transformé en lettre</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i>Saisie d'un chiffre qui sera affiché en lettre dans votre document</i></td>").appendTo($Tr)
                                break;
                            case 6:
                                $("<i class='fas fa-table-list'></i>").appendTo($Td);
                                var $Td = $("<td style='width:100%;font-weight:bold;'>Champs texte</td>").appendTo($Tr)
                                var $Tr = $("<tr/>").appendTo($Table)
                                $("<td style='font-size:65%;'><i>Choisissez un texte dans une liste</i></td>").appendTo($Tr)
                                break;
                        }
                        var $Tr = $("<tr/>").appendTo($Table)
                    },
                    onItemClick: function (e) {
                        mCreateChamp(e.itemData)
                        tt.hide()
                    }
                })
            }
        }).dxCtrlTooltip("instance")
        tt.show()

        function mCreateChamp(typeChamp) {
            var lib = ""
            switch (typeChamp) {
                case 1: lib = "texte"; break;
                case 2: lib = "texte multiligne"; break;
                case 3: lib = "date"; break;
                case 4: lib = "chiffre"; break;
                case 5: lib = "chiffre en lettre"; break;
                case 6: lib = "liste de choix"; break;
            }
            var idx = 1
            var newNom = "Nouveau champ " + lib + " " + idx
            while (option.lstChampSaisie.filter(function (champ) { return champ.nom == newNom }).length > 0) {
                idx += 1
                newNom = "Nouveau champ " + lib + idx
            }
            var nouveauChamp = {
                nom: newNom,
                detail: "",
                type_champ: typeChamp,
                value: "",
                tri: dxListChamp.option("items").length + 1,
                idx: mGetMaxIndexChamp() + 1
            }
            mDisplayChamp(nouveauChamp, function () {
                option.lstChampSaisie.push(nouveauChamp)
            })
        }
    }

    function mDisplayChamp(champ, funcOk) {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            shading: true,
            showMaximize: false,
            width: 500,
            height: "auto",
            title: "Nouveau champ",
            contentTemplate: function (contentElement) {
                var dxNom = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom fusion champ",
                    hint: "Nom du champ affiché dans votre document",
                    value: champ.nom,
                    onValueChanged: function (e) { champ.nom = ((e.value == null) ? "" : e.value) },
                    onContentReady: function (e) { window.setTimeout(function () { e.component.focus() }, 500) }
                }).dxCtrlTextBox("instance")
                $("<br/>").appendTo(contentElement)
                $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Description champ",
                    hint: "La description du sera affiché pour l'utilisateur pour décrire le champ",
                    multiline: true,
                    value: champ.detail,
                    onValueChanged: function (e) { champ.detail = ((e.value == null) ? "" : e.value) }
                }).dxCtrlTextBox("instance")
                $("<br/>").appendTo(contentElement)

                //mAddCtrlChamp(contentElement, champ.type_champ, "Valeur", "Saisissez une valeur par défaut. Laissez vide si vous ne voulez pas de valeur à l'initialisation du champ", champ.value, "Valeur par défaut", function (e) { champ.value = ((e.value == null) ? "" : e.value) })

                $("<br/>").appendTo(contentElement)
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (typeof funcOk != 'undefined') funcOk()
                        mRempliChamp()
                        option.onLstChampSaisieChanged(option.lstChampSaisie)
                        popup.hide()
                    },
                    function () { //annuler
                        popup.hide();
                    })
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    function mAddCtrlChamp(content, typeChamp, nom, description, value, placeholder, onValueChanged) {
        switch (typeChamp) {
            case 1:
                return $("<div/>").appendTo(content).dxTextBox({
                    labelMode: 'floating',
                    label: nom,
                    hint: description,
                    value: value,
                    onValueChanged: onValueChanged
                }).dxTextBox("instance")
                break;
            case 2:
                return $("<div/>").appendTo(content).dxTextArea({
                    labelMode: 'floating',
                    label: nom,
                    hint: description,
                    value: value,
                    onValueChanged: onValueChanged
                }).dxTextArea("instance")
                break;
            case 3:
                return $("<div/>").appendTo(content).dxDateBox({
                    labelMode: 'floating',
                    label: nom,
                    hint: description,
                    value: value,
                    onValueChanged: onValueChanged
                }).dxDateBox("instance")
                break;
            case 4:
                return $("<div/>").appendTo(content).dxNumberBox({
                    labelMode: 'floating',
                    label: nom,
                    hint: description,
                    value: value,
                    onValueChanged: onValueChanged
                }).dxNumberBox("instance")
                break;
            case 5:
                return $("<div/>").appendTo(content).dxNumberBox({
                    labelMode: 'floating',
                    format: '#',
                    label: nom,
                    hint: description,
                    value: value,
                    onValueChanged: onValueChanged
                }).dxNumberBox("instance")
                break;
        }
    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container; }
    this.component = function () { }

    mConstruit();
}